export default {
  colorDefault: {
    backgroundColor: "#eeeeee"
  }
};
